export default __webpack_public_path__ + "static/lframe-travel-loan-2b65046cabdf4ae3ae37f5027ddd1415.webp";